module.exports = __webpack_public_path__ + "img/bg05.6c3d14a4.gif";